(function() {
  var __snippets__ = {};
  (function() {
    var element = document.getElementById("snippets-script");
    var attribute = element ? element.getAttribute("data-snippets") : '';
    var snippets = attribute.split(",").filter(Boolean);

    for (var i = 0; i < snippets.length; i++) {
      __snippets__[snippets[i]] = true;
    }
  })();
  (function() {
  if (!__snippets__["product-template"] && !Shopify.designMode) return;
  try {
    // Get the iframe element
const iframe = document.getElementById('klaviyo-bis-iframe');

// Wait for iframe to load
iframe.onload = function() {
    // Access the iframe's document
    const iframeDoc = iframe.contentDocument || iframe.contentWindow.document;
    
    // Method 1: Add CSS rules directly
    const style = iframeDoc.createElement('style');
    style.textContent = `
        .modal-title {
            color: red;
            font-size: 16px;
        }
    `;
    iframeDoc.head.appendChild(style);
    
    // Method 2: Modify element styles directly
    const element = iframeDoc.querySelector('.modal-title');
    if (element) {
        element.style.backgroundColor = 'blue';
        element.style.padding = '10px';
    }
};
  } catch(e) { console.error(e); }
})();

})();
